import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { CloseOutlinedIcon } from '../../constants/images';

import theme from '../../theme';

const ModalTitle = ({ editMode, isLoading, modalContent, handleClose }) => {

  return (
    <Stack
      variant="between-center"
      sx={{
        padding: '16px 16px 0 32px',
        borderBottom: `1px solid ${theme.palette.grey.w300}`,
      }}
    >
      <Typography variant='h4'>
        {
          modalContent.render === 'locale' ? (
            editMode ? (
              <FormattedMessage id={modalContent.subTitle} />
            ) : (
              <FormattedMessage id={modalContent.title} />
            )
          ) : (
            editMode ? (
              modalContent.subTitle
            ) : (
              modalContent.title
            )
          )
        }
      </Typography>

      <IconButton
        variant='title'
        onClick={handleClose}
        disabled={isLoading ? true : false}
      >
        <CloseOutlinedIcon variant='md_24' />
      </IconButton>

    </Stack>
  )
}

export default ModalTitle;